import React from 'react';
import * as S from './styles';

export type PottencialSelectCardProps = {
  setSelected: (selected: string) => void;
  selected: string;
  offers: {
    status?: string;
    nomeSeguro: string;
    planoSelecionado: string;
    valorParcela: number;
    premioTotal: number;
    quantidadeParcela: number;
  }[];
};

function maskMoney(valor: number) {
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

// Helper function to check if product status is rejected
const isRejected = (status?: string): boolean => {
  if (!status) return false;
  const rejectedStatuses = ['denied', 'refused', 'refusedbiometry', 'expired'];
  return rejectedStatuses.some(rejected => status.toLowerCase().includes(rejected));
};

export const PottencialSelectCards = ({
  offers,
  selected,
  setSelected
}: PottencialSelectCardProps) => {

  const handleCardSelect = (planoSelecionado: string) => {
    setSelected(planoSelecionado);
  };


  return (
    <S.Wrapper>
      {offers &&
        offers.map((option, i) => {
          const isSelected = selected === option.nomeSeguro;
          const rejected = isRejected(option.status);
          const hasValue = option.valorParcela > 0;
          const isDisabled = rejected || !hasValue;

          return (
            <S.Card
              key={i}
              isSelected={isSelected}
              onClick={() => !isDisabled && handleCardSelect(option.nomeSeguro)}
              style={{ 
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer'
              }}
            >
              <S.Input
                type="checkbox"
                checked={isSelected}
                onChange={() => !isDisabled && handleCardSelect(option.nomeSeguro)}
                disabled={isDisabled}
              />
              <S.Content>
                <S.Row>
                  <h2 style={{ marginTop: 3 }}>
                    {option.nomeSeguro}
                    {isDisabled && <span style={{ color: 'red', marginLeft: 8 }}>(Indisponível)</span>}
                  </h2>
                </S.Row>
                <p>
                  Parcela: <b>{option.quantidadeParcela}x {maskMoney(option.valorParcela)}</b>
                </p>
                <p>
                  Prêmio Total: <b>{maskMoney(option.premioTotal)}</b>
                </p>
              </S.Content>
            </S.Card>
          );
        })}
    </S.Wrapper>
  );
};
export default PottencialSelectCards;
